import { useSearchParams } from 'react-router-dom';
import { useCallback } from 'react';

/**
 * useState-like hook that syncs a single value to a URL query parameter.
 * Uses replace:true so deal clicks don't pollute browser history.
 * Returns [value, setValue] where value is a string or null.
 */
export function useURLState(paramName) {
  const [searchParams, setSearchParams] = useSearchParams();

  const value = searchParams.get(paramName);

  const setValue = useCallback((newValue) => {
    setSearchParams((prev) => {
      const next = new URLSearchParams(prev);
      if (newValue == null || newValue === '') {
        next.delete(paramName);
      } else {
        next.set(paramName, String(newValue));
      }
      return next;
    }, { replace: true });
  }, [paramName, setSearchParams]);

  return [value, setValue];
}
